
import React from "react";
import { QueEsSection } from "./sections/QueEsSection";
import { PorQue2026Section } from "./sections/PorQue2026Section";
import { HerramientasSection } from "./sections/HerramientasSection";
import { VibeCodingSeoSection } from "./sections/VibeCodingSeoSection";
import { EjemploRealSection } from "./sections/EjemploRealSection";
import { LimitacionesSection } from "./sections/LimitacionesSection";
import { ConclusionSection } from "./sections/ConclusionSection";

export function ArticleContent() {
  return (
    <div className="prose prose-lg prose-invert max-w-none">
      <QueEsSection />
      <PorQue2026Section />
      <HerramientasSection />
      <VibeCodingSeoSection />
      <EjemploRealSection />
      <LimitacionesSection />
      <ConclusionSection />
    </div>
  );
}
